import { Component, Input, SimpleChanges } from '@angular/core';
import { LauncherConfigService } from '../../shared/services/launcher.service';

@Component({
  selector: 'app-maintenance-page',
  styleUrls: ['./maintenance-page.component.scss'],
  templateUrl: './maintenance-page.component.html',
})
export class MaintenancePageComponent {
  @Input() timeFrom?: string;
  @Input() timeTo?: string;
  formattedFrom = '';
  formattedTo = '';
  constructor(private launcherConfigService: LauncherConfigService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['timeFrom']) {
      this.formattedFrom = this.timeFrom;
    }
    if (changes['timeTo']) {
      this.formattedTo = this.timeTo;
    }
  }

  get isAdmin(): boolean {
    return this.launcherConfigService.isAdmin;
  }

  onAdminContinue(): void {
    this.launcherConfigService.setAdminBypass(true);
    window.location.href = '/';
  }
}
